const initialState = {
    responseCategoriesList: [],
    responseCategory: [],
    responseProductsLineList: [],
    responseProductLine: [],
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "CATEGORIES_RESPONSE_LIST":
            if (action.value.detail !== undefined)
                newState.responseCategoriesList = []
            else
                newState.responseCategoriesList = action.value;

            newState.responseCategory = []
            break;
        case "CATEGORY_RESPONSE":
            newState.responseCategory = action.value;
            break;
        case "PRODUCTS_LINE_LIST_RESPONSE":
            if (action.value.detail !== undefined) {
                newState.errorProductsLineList = true;
            } else {
                newState.errorProductsLineList = false;
            }
            newState.responseProductsLineList = action.value;
            break;
        case "PRODUCT_LINE_RESPONSE":
            if (action.value.detail !== undefined) {
                newState.errorProductLine = true;
            } else {
                newState.errorProductLine = false;
            }
            newState.responseProductLine = action.value;
            break;

        default:
            return newState;
    }

    return newState;
};

export default reducer;